export function canAnalyzeVideo(value = "") {
  if (value.startsWith("/api/files/")) return true;
  try {
    const url = new URL(value), host = url.hostname.toLowerCase(), parts = url.pathname.replace(/^\/+|\/+$/g, "").split("/");
    if (url.protocol !== "https:" || url.username || url.password || (url.port && url.port !== "443")) return false;
    const short = ["youtu.be", "www.youtu.be"].includes(host);
    if (!short && !["youtube.com", "www.youtube.com", "m.youtube.com", "music.youtube.com", "youtube-nocookie.com", "www.youtube-nocookie.com"].includes(host)) return false;
    const id = short && parts.length === 1 ? parts[0] : !short && url.pathname === "/watch" ? url.searchParams.get("v") : !short && parts.length === 2 && ["embed", "shorts", "live"].includes(parts[0]) ? parts[1] : "";
    return /^[A-Za-z0-9_-]{11}$/.test(id || "");
  } catch { return false; }
}
